<template>
<div class="coordinates-container">
    <div id="map-scale"></div>
    <div class="map-coordinates">
        <div id="map-coordinates"></div>
        <div class="map-coordinates-field">
          <b-form-select v-model="coordinateSystem" title="Układ współrzędnych">
              <option disabled>Układ współrzędnych</option>
              <option v-for="system in coordinateSystems"
                  :key="system.epsg"
                  :value="system.epsg">
                  {{system.name}}
              </option>
          </b-form-select>
        </div>
        <div class="map-coordinates-field">
          <b-input-group>
            <b-form-select v-model="selectedScaleOption" :disabled="locked" title="Skala">
              <option :value="null" disabled>Wybierz skalę</option>
              <option v-for="(resolution, index) in resolutions"
                :key="index"
                :value="index">
                1:{{resolution.scale}}
              </option>
              <option :value="CUSTOM_SCALE_OPTION">1:(Dowolna)</option>
            </b-form-select>
            <b-input-group-append  v-show="selectedScaleOption === CUSTOM_SCALE_OPTION">
              <b-form-input v-model="customScale" :type="'number'" :min="10" :max="scaleMax"
              :class="{ 'is-invalid': !customScaleValid, 'form-control' : true }" title="Mianownik skali"/>
              <b-btn variant="success" @click="setCustomResolution" title="OK">Ustaw</b-btn>
            </b-input-group-append>
          </b-input-group>
        </div>
    </div>
  </div>
</template>

<script>
import { CoordinateSystems } from "../common/mapEnums";
import {
  MAP_COORDINATE_SYSTEM_SET,
  MAP_RESOLUTION_SET,
  MAP_SCALE_SET
} from "../store/mutations.type";
import { Api as ApiScales } from '../api/api-skale.js'

const INCHES_PER_METER = 39.37;
const BASE_DPI = 96;

export default {
  name: "MapCoordinates",
  data() {
    return {
      coordinateSystems: CoordinateSystems,
      resolutions: [],
      customScale: undefined,
      locked: true,
      selectedScaleOption: null,
      CUSTOM_SCALE_OPTION: -1,
      syncedResolution: null,
      scaleMax: 50000000
    };
  },
  methods: {
    setCustomResolution() {
      if (this.customScaleValid) {
        let resolution = this.getResolutionFromScale(this.customScale);
        this.syncResolutionWithSelected(resolution);
      }
    },
    getResolutionFromScale(denominator) {
      return 1 / (1 / denominator * INCHES_PER_METER * BASE_DPI * window.devicePixelRatio);
    },
    getScaleFromResolution(resolution) {
     return Math.round(resolution * INCHES_PER_METER * BASE_DPI * window.devicePixelRatio);
    },
    syncResolutionWithSelected(resolution) {
      this.syncedResolution = resolution;
      this.$store.commit(MAP_RESOLUTION_SET, resolution);
    },
    syncResolutionWithMap(resolution) {
      this.syncedResolution = resolution;
      this.customScale = this.getScaleFromResolution(resolution);
      this.selectedScaleOption = this.CUSTOM_SCALE_OPTION;
    }
  },
  computed: {
    coordinateSystem: {
      get() {
        return this.$store.getters.coordinateSystem;
      },
      set(value) {
        this.$store.commit(MAP_COORDINATE_SYSTEM_SET, value);
      }
    },
    customScaleValid() {
      return this.customScale && this.customScale > 0 && this.customScale <= this.scaleMax;
    }
  },
  mounted() {
    var self = this;
    const api = new ApiScales();

    api.getSkale({})
    .then(function(response) {
      response.body.skale.forEach(scale => self.resolutions.push({
        scale: scale.mianownik,
        resolution: self.getResolutionFromScale(scale.mianownik)
      }))}
    ).catch(function () {})
    .finally(_ => self.locked = false);
  },
  created() {
    let self = this;
    this.$store.watch(
      () => self.$store.getters.resolution,
      (value, oldValue) =>  {
        if (value != self.syncedResolution) {
          self.syncResolutionWithMap(value);
        }
      }
    );

    this.$store.watch(
      () => self.$store.getters.scale,
      (v) => {
        if (v != self.customScale) {
          const indexOfStandardResolution = self.resolutions.findIndex(r => r.scale == v);
          self.selectedScaleOption = indexOfStandardResolution;
          self.customScale = v;
          self.$store.commit(MAP_RESOLUTION_SET, self.getResolutionFromScale(self.customScale));
        }
      }
    );
  },
  watch: {
    selectedScaleOption: function (val) {
      if (val != this.CUSTOM_SCALE_OPTION && val >= 0) {
        this.customScale = this.resolutions[val].scale;
        let resolution = this.resolutions[val].resolution;
        this.syncResolutionWithSelected(resolution);
      }
    },
    customScale(v) {
      this.$store.commit(MAP_SCALE_SET, v);
    }
  }
};
</script>

<style>
.coordinates-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-self: flex-end;
  align-self: flex-end;
}
.map-coordinates {
  background-color: rgba(0, 60, 136, 0.3);
  border-radius: 4px;
  padding: 5px;
  margin: 0.5em;
  min-width: 230px;
  text-align: center;
}
.map-coordinates-field {
  pointer-events: all;
}
#map-coordinates {
  color: #fff;
}
#map-scale {
  position: relative;
}
.ol-scale-line {
  bottom: 0.5em;
  right: 0.5em;
  left: inherit;
}
</style>
